export enum ServiceNature {
  GENERAL = 'GENERAL',
  CORRECTIVE = 'CORRECTIVE',
  PREVENTIVE = 'PREVENTIVE',
}
